var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22408488,3.27155404 L2.59459816,4.90104076 C2.48197187,5.01366704 2.29985276,5.01366704 2.18842463,4.90104076 L1.91764228,4.6302584 C1.80501599,4.51763212 1.80501599,4.33551301 1.91764228,4.22408488 L3.0726608,3.06906635 L1.91764228,1.91404782 C1.80501599,1.80142153 1.80501599,1.61930243 1.91764228,1.50787429 L2.18722648,1.23469564 C2.29985276,1.12206935 2.48197187,1.12206935 2.5934,1.23469564 L4.22288672,2.86418236 C4.33671116,2.97680864 4.33671116,3.15892775 4.22408488,3.27155404 L4.22408488,3.27155404 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRight);
export default __webpack_public_path__ + "static/media/angle-right.1a4202d82853cfce00d12e0d0c9908f7.svg";
export { ForwardRef as ReactComponent };